import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

const useStyles = makeStyles()(theme => ({
  container: {
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(0.5),
    backgroundColor: theme.palette.shades.shade03,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
  },
}))

interface Props {
  vin?: string
}

const VinTile: React.FC<Props> = ({ vin }) => {
  const { classes } = useStyles()

  if (!vin) return null

  return (
    <Box className={classes.container}>
      <Typography variant="overline">{vin}</Typography>
    </Box>
  )
}

export default VinTile
